import { render, staticRenderFns } from "./smallEdit.vue?vue&type=template&id=1073486f"
import script from "./smallEdit.vue?vue&type=script&lang=js"
export * from "./smallEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1073486f')) {
      api.createRecord('1073486f', component.options)
    } else {
      api.reload('1073486f', component.options)
    }
    module.hot.accept("./smallEdit.vue?vue&type=template&id=1073486f", function () {
      api.rerender('1073486f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/majorObject/majorSmallType/smallEdit.vue"
export default component.exports